module.exports = __webpack_public_path__ + "static/media/document_choice.0c279d6e.svg";